import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'next/router';
import viewStyles from '../ViewGuests/ViewGuests.module.scss';
import styles from './ViewOrgMembers.module.scss';
import ModalBase, { BaseModalProps } from '../ModalBase/ModalBase';
import { showQuickView } from '../../../util/modalFlows';

interface PersonProps {
  self: any;
  person: any;
  router: any;
}

const Person = ({ self, person, router }: PersonProps) => (
  <div
    className={viewStyles.person}
    onClick={() => {
      showQuickView(person._id, self._id, router);
    }}
  >
    <div className="pic">
      {person.photo?.url || person.photoUrl ? (
        <img src={person.photo?.url || person.photoUrl} alt="" />
      ) : (
        <i className="fas fa-user-alt" />
      )}
    </div>
    <div className={viewStyles.guestInfo}>
      <div className="name">
        {person.name || `${person.firstName} ${person.lastName}`}
      </div>
    </div>
  </div>
);

interface ViewOrgMembersProps {
  self: any;
  members: any[];
  router: any;
  baseModalProps: BaseModalProps;
}

const ViewOrgMembers = ({ self, members, router, baseModalProps }: ViewOrgMembersProps) => {
  const admins = members.filter(({ role }) => role === 'admin');
  const hosts = members.filter(({ role }) => role === 'host');

  return (
    <ModalBase
      baseModalProps={baseModalProps}
      back_img="Back"
      contentClassName="basic"
    >
      <div className={styles.wrapper}>
        <h2 className="modalTitle">Members</h2>
        <h3>Admin</h3>
        {admins.map(({ user }) => (
          <Person key={user._id} self={self} person={user} router={router} />
        ))}
        {hosts.length > 0 && <h3>Hosts</h3>}
        {hosts.map(({ user }) => (
          <Person key={user._id} self={self} person={user} router={router} />
        ))}
      </div>
    </ModalBase>
  );
};

interface StateProps {
  self: any;
}

const mapStateToProps = (state: any): StateProps => ({
  self: state.user.user
});

export default withRouter(connect(mapStateToProps, null)(ViewOrgMembers));
